module.exports = __webpack_public_path__ + "img/IMG_1198.91c81f46.jpeg";